import {Actions, createEffect, ofType} from '@ngrx/effects';
import {mergeMap} from 'rxjs/operators';
import {SendAction, SendActionFailure, SendActionSuccess} from '../actions/external-actions.action';
import {Injectable} from '@angular/core';
import {ExternalActionService} from '../../../services/external-action.service';


@Injectable()
export class ExternalActionsEffect {

    SendAction$ = createEffect(() => this.action$
        .pipe(
            ofType(SendAction),
            mergeMap(({actionId}) =>
                this.externalActionsService.execute(actionId)
            )
        ));

    SendActionSuccess$ = createEffect(() => this.action$
        .pipe(
            ofType(SendActionSuccess)
        ), {
            dispatch: false
        });

    SendActionFailure$ = createEffect(() => this.action$
        .pipe(
            ofType(SendActionFailure)
        ), {
            dispatch: false
        });


    constructor(
        private action$: Actions,
        private externalActionsService: ExternalActionService
    ) {
    }
}
